// extracted by mini-css-extract-plugin
export default {"h3":"Card_h3__C0sVO","h5":"Card_h5__zhfsR","flag":"Card_flag__JD7EQ","card":"Card_card__z8HfQ"};